import * as React from 'react'
import { RAQuestion } from '../../models';
import { Link } from 'react-router-dom';

interface RAQuestionProps {
  question: RAQuestion,
  questionNo: number,
}

class Question extends React.Component<RAQuestionProps> {
  public state = {
    error: '',
    selectedAnswerId: 0
  }

  public handleAnswerClick = (event: any) => {
    this.setState({selectedAnswerId: event.target.value, error: ''});
  }

  public handleSubmit = (event: any) => {
    event.preventDefault();

    this.setState({error: ''});

    if(this.state.selectedAnswerId === 0) {
      this.setState({error: 'Please select an answer before continuing'});
      return;
    }

    // Temp solution until hooked up with redux
    // TODO - replace with submit answer below
    window.location.href = `/ra/${this.props.questionNo + 1}`;
  }

  public render() {
    return (
      <div className='question' key={this.props.question.id}>
        <form onSubmit={this.handleSubmit}>
          <h6>{this.props.question.text}</h6>
          {
            this.state.error !== '' && (
              <div className='error'>
                {this.state.error}
              </div>
            )
          }
          <ul className='answers'>
            {
              this.props.question.answers.map(answer => {
                return (
                  <li key={answer.id}>
                    <input type='radio' key={answer.id} value={answer.id} name={`question_${this.props.question.id}`} onClick={this.handleAnswerClick} />
                    <label>{answer.text}</label>
                  </li>
                );
              })
            }
          </ul>
          {
            this.props.questionNo > 1 && (
              <Link className='button primary-button back-button' to={{pathname: `/ra/${this.props.questionNo-1}`}}>
                &lt; Previous
              </Link>
            )
          }
          <button type='submit' className='button primary-button'>Next &gt;</button>
        </form>
      </div>
    )
  }
}

export default Question;